module.exports = __webpack_public_path__ + "img/document-forward.50fa78f0.svg";